import React, { useState } from "react"
import * as Yup from "yup"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Form,
  Input,
  FormFeedback,
  Button,
} from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useCreatePermissionMutation } from "store/api/permissions/permissions.api"
import { useFormik } from "formik"
import { Link, useNavigate } from "react-router-dom"
import leftArrow from "../../assets/images/icons/left-arrow.svg"
import DownArrowColor from "../../assets/images/icons/down-arrow-color.svg"
import UpArrowColor from "../../assets/images/icons/up-arrow-color.svg"
import users from "../../assets/images/icons/users.svg"
import bag from "../../assets/images/icons/bag.svg"
import conversion from "../../assets/images/icons/conversion-rate.svg"
import investor from "../../assets/images/icons/investor.svg"
import user from "../../assets/images/icons/user.svg"
import wallet from "../../assets/images/icons/wallet.svg"
import file from "../../assets/images/icons/file-type.svg"
import check from "../../assets/images/icons/right-check.svg"
import documentfile from "../../assets/images/icons/document.svg"

const RegulatoryComplianceReports = () => {
  const navigate = useNavigate()
  const [mutate] = useCreatePermissionMutation()
  //meta title
  document.title = "Wealth Partner Details"

  const onFormSubmit = async (values) => {
    try {
      const response = await mutate(values).unwrap()
      if (response.success) {
        navigate("/wealth-partners")
      }
    } catch (error) {}
  }

  const horizontalformik = useFormik({
    initialValues: {
      module: "",
      key: "",
      label: "",
    },
    validationSchema: Yup.object({}),

    onSubmit: (values) => {
      onFormSubmit(values)
    },
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <div className="d-flex align-items-center gap-2 mb-4">
            <Link to={"/unlisted-bond"}>
              <img src={leftArrow} alt="" />
            </Link>
            <div className="page-title-name">Unlisted Bond Detail </div>
          </div>
          {/* <Breadcrumbs
              title={"Wealth Partner Details"}
              breadcrumbItem={"Wealth Partner Details"}
            /> */}
          <Row>
            <Col xl={12}>
              <div className="d-flex align-items-center mb-4 justify-content-between">
                <CardTitle className="">
                  Bond Code: <span> ULB2025-ABC-01 </span>
                </CardTitle>
                <div className="card-status">
                  <div className="approved">
                    <span /> Approved
                  </div>
                  {/* <div className="pending">
                        <span /> Pending
                      </div> */}
                </div>
              </div>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">About the Issuer</CardTitle>
                  <Form onSubmit={horizontalformik.handleSubmit}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Issuer Name <span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Sector <span className="error">*</span>
                        </Label>
                        <select
                          disabled
                          name="entity_type"
                          className="form-select pageSize"
                        >
                          <option value={"ICD"}>ICD</option>
                          <option value={"Bond"}>Bond</option>
                          <option value={"Reit"}>Reit</option>
                        </select>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Financial Highlights <span className="error">*</span>
                        </Label>
                        <select
                          disabled
                          name="entity_type"
                          className="form-select pageSize"
                        >
                          <option value={"ICD"}>ICD</option>
                          <option value={"Bond"}>Bond</option>
                          <option value={"Reit"}>Reit</option>
                        </select>
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Website <span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          File Browser <span className="error">*</span>
                        </Label>
                        <div className="input-wrapper">
                          <Input
                            disabled
                            name="Name "
                            type="number"
                            className="form-control"
                            id="horizontal-email-id "
                            placeholder="abc.pdf"
                            value={horizontalformik.values.module}
                            onChange={horizontalformik.handleChange}
                            onBlur={horizontalformik.handleBlur}
                            invalid={
                              horizontalformik.touched.module &&
                              horizontalformik.errors.module
                                ? true
                                : false
                            }
                          />
                          <img src={documentfile} alt="" />
                        </div>
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Investment Details</CardTitle>
                  <Form onSubmit={horizontalformik.handleSubmit}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Instrument Type<span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Face Value <span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Minimum Investment<span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Rate of Interest<span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Interest Payment Frequency
                          <span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Tenure<span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Call Option<span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Put Option<span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Mode of Issue<span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Security<span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Debenture Trustee <span>(If applicable)</span>
                          <span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Holding<span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>

              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Rating Details</CardTitle>
                  <Form onSubmit={horizontalformik.handleSubmit}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Credit Rating <span>(If applicable)</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col xl={6}>
                        <Label
                          htmlFor="horizontal-firstname-Input"
                          className="col-form-label"
                        >
                          Credit Rating Agency Name
                          <span className="error">*</span>
                        </Label>
                        <Input
                          disabled
                          name="module"
                          type="text"
                          className="form-control"
                          id="horizontal-firstname-Input"
                          placeholder="Investment Amount"
                          value={horizontalformik.values.module}
                          onChange={horizontalformik.handleChange}
                          onBlur={horizontalformik.handleBlur}
                          invalid={
                            horizontalformik.touched.module &&
                            horizontalformik.errors.module
                              ? true
                              : false
                          }
                        />
                        {horizontalformik.errors.module &&
                        horizontalformik.touched.module ? (
                          <FormFeedback type="invalid">
                            {horizontalformik.errors.module}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col xl={12}>
              <CardTitle className="pb-4">Downloadable Docs</CardTitle>
              <div className="documents-section">
                <div className="documents-box">
                  <div className="file-type">
                    <img src={file} alt="" />
                    <p>Investment Agreement.pdf</p>
                  </div>
                  <div className="verified-user">
                    <img src={check} alt="" /> Verified
                  </div>
                </div>
                <div className="documents-box">
                  <div className="file-type">
                    <img src={file} alt="" />
                    <p>Bond Certificate.pdf</p>
                  </div>
                  <div className="verified-user">
                    <img src={check} alt="" /> Verified
                  </div>
                </div>
                <div className="documents-box">
                  <div className="file-type">
                    <img src={file} alt="" />
                    <p>KYC Acknowledgement.pdf</p>
                  </div>
                  <div className="verified-user">
                    <img src={check} alt="" /> Verified
                  </div>
                </div>
              </div>
              <div className="buttons">
                <Button className="counteroffer">Edit Bond</Button>
                <Button className="reject">Delete Bond</Button>
                {/* <Button className="reject">Reject Request</Button> */}
                {/* <Button className="approve">Approve Request</Button> */}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default RegulatoryComplianceReports
